export const msalConfig = {
 auth: {
  clientId: "ec9c0094-121d-4414-909c-781d820db587",
  authority: "https://evenflowext.ciamlogin.com/1b22404b-606d-4a0a-9f9a-b8216f583aa2",
  knownAuthorities: ["evenflowext.ciamlogin.com"],
  redirectUri: `${window.location.origin}`,
  postLogoutRedirectUri: `${window.location.origin}`,
 },
 cache: {
  cacheLocation: "sessionStorage",
  storeAuthStateInCookie: false,
 },
 system: {
  allowNativeBroker: false,
  windowHashTimeout: 90000, // 90 seconds - increased from default 60
  iframeHashTimeout: 10000, // 10 seconds for iframe operations
  loadFrameTimeout: 10000,  // 10 seconds for frame loading
  navigateFrameWait: 0,     // Don't wait for frame navigation
  loggerOptions: {
   loggerCallback: (level: any, message: string, containsPii: boolean) => {
    if (containsPii) {
     return;
    }
    // Only log errors and warnings (level 1 = Error, level 2 = Warning)
    if (level <= 2) {
     //console.log(message);
    }
   },
   logLevel: 2, // Warning level - reduces verbose output
  },
 },
};